/**
* @brandOverride URBNWeb
*/
import { coreReducer } from '../../../core/js/reducers/coreReducer';
import { cacheReducer } from '../../../category/js/reducers/cacheReducer';
import { pdpReducer } from '../reducers/productReducer';
import { quickshopReducer } from '../reducers/quickshopReducer';
import { registryReducer } from '../../../registry/js/reducers/registryReducer';

/**
 * Render a template string
 * @param {Number} state - The current state
 * @param {String} action - The action that was emitted
 * @returns {object} Redux reducer structure
 */
export function productApp(state = {}, action = {}) {
    return {
        cache: cacheReducer(state.cache, action),
        core: coreReducer(state.core, action),
        product: pdpReducer(state, state.product, action),
        quickshop: quickshopReducer(state, state.quickshop, action),
        registry: registryReducer(state.registry, action)
    };
}

export default productApp;
